import React, { useState } from "react";
import ReactModal from "react-modal";

//ReactModal.setAppElement("#app");

const Popup = ({
                   trigger,
                   modal = true,
                   lockScroll = true,
                   closeOnDocumentClick = true,
                   open,
                   onClose,
                   className = "",
                   overlayClassName = "bm-modal-overlay",
                   children
               }) => {
    const [isOpen, setIsOpen] = useState(false);

    const internalIsOpen = typeof open === "boolean" ? open : isOpen;
    const internalOnClose = typeof onClose === "function" ? onClose : () => setIsOpen(false);

    const handleOpen = () => {
        if (typeof open !== "boolean") setIsOpen(true);
    };

    const handleRequestClose = () => {
        if (closeOnDocumentClick) internalOnClose();
    };

    return (
        <>
            {trigger && (
                <span onClick={handleOpen}>
                    {typeof trigger === "function" ? trigger(handleOpen) : trigger}
                </span>
            )}

            <ReactModal
                ariaHideApp={false}
                isOpen={internalIsOpen}
                onRequestClose={handleRequestClose}
                shouldCloseOnOverlayClick={closeOnDocumentClick}
                shouldCloseOnEsc={true}
                className={className}
                overlayClassName={overlayClassName}
                ariaHideApp={false}
                bodyOpenClassName={lockScroll ? "ReactModal__Body--open" : ""}
            >
                {typeof children === "function" ? children(internalOnClose) : children}
            </ReactModal>
        </>
    );
};

export default Popup;
